import React from 'react';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import { useMedia } from 'util/event';
import { BlogResource } from 'util/api/swaggerApi/data-contracts';

import SquareBracket from 'components/atoms/SquareBracket';
import CardTopics from 'components/molecules/CardTopics';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import IconArrow from 'images/icon/arrow-right.inline.svg';

import styles from './index.module.css';

interface CarouselTopicProperty {
	className?: string;
	data: BlogResource[];
	uniqueId: string;
}

const CarouselTopic: React.FC<CarouselTopicProperty> = ({ className, data, uniqueId }) => {
	const media = useMedia();

	return (
		<div className={classnames(styles.carouselWrapper, className)}>
			<Swiper
				className={styles.carousel}
				modules={[Navigation]}
				slidesPerView={media === 'desktop' ? 3.36 : 1.1}
				spaceBetween={media === 'desktop' ? 30 : 16}
				navigation={{
					prevEl: `.button-prev-${uniqueId}`,
					nextEl: `.button-next-${uniqueId}`,
				}}
				onRealIndexChange={item => {
					item.navigation.update();
				}}
				loop
			>
				{data &&
					data.map(item => (
						<SwiperSlide key={item.id} className={styles.carouselItem}>
							<CardTopics
								type="basic"
								linkTo={`/topics/${item.id}`}
								image={item.image || ''}
								title={item.title || ''}
								subtitle={item.subtitle || ''}
							/>
						</SwiperSlide>
					))}
			</Swiper>
			{media === 'desktop' && (
				<>
					<button
						type="button"
						className={classnames(`button-prev-${uniqueId}`, styles.buttonPrev)}
						aria-label="prev"
					>
						<IconArrow />
					</button>
					<button
						type="button"
						className={classnames(`button-next-${uniqueId}`, styles.buttonNext)}
						aria-label="next"
					>
						<IconArrow />
					</button>
				</>
			)}
			<SquareBracket className={classnames(styles.squareBracket, styles.left)} side="left" />
			<SquareBracket className={classnames(styles.squareBracket, styles.right)} side="right" />
		</div>
	);
};

export default CarouselTopic;
